var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 13.3h53.3v13.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m26 20 1.1.2-.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m27.3 20-1 .2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "M26.5 19.4v1l2.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m26.9 20.6-.6-1 2.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m26.5 20.6.5-1-2.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m26.9 19.4-.2 1-2.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m27.2 19.6-1 .5 1.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m26.1 20.4.8-.8 1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m27.2 20.4-.8-.8-1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m26.1 19.6 1 .5-1.7 1.7zm11-3.2 1.1.3-.4-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38.4 16.4-1 .3.4-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.6 15.8.1 1.1 2.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38 17-.6-1 2.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.6 17 .5-1-2.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38 15.8-.2 1.1-2.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38.3 16-1 .5 1.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.2 16.8.8-.8 1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38.3 16.8-.8-.8-1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.2 16 1 .5-1.7 1.7zm-.1 7.1 1.1.2-.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38.4 23.1-1 .2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.6 22.5.1 1.1 2.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38 23.7-.6-1 2.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.6 23.7.5-1-2.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38 22.5-.2 1.1-2.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38.3 22.7-1 .5 1.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.2 23.5.8-.8 1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m38.3 23.5-.8-.8-1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m37.2 22.7 1 .5-1.7 1.7zm-22.3-6.3 1.1.3-.4-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m16.2 16.4-1 .3.4-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "M15.4 15.8V17l2.3-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15.8 17-.6-1 2.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15.4 17 .5-1-2.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15.8 15.8-.2 1.1-2.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m16.1 16-1 .5 1.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15 16.8.8-.8 1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m16.1 16.8-.8-.8-1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15 16 1 .5-1.7 1.7zm-.1 7.1 1.1.2-.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m16.2 23.1-1 .2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "M15.4 22.5v1.1l2.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15.8 23.7-.6-1 2.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15.4 23.7.5-1-2.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15.8 22.5-.2 1.1-2.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m16.1 22.7-1 .5 1.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15 23.5.8-.8 1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m16.1 23.5-.8-.8-1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "m15 22.7 1 .5-1.7 1.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/hn.d23f2928eb5292e8670fec63d8feb7a5.svg";
export { ForwardRef as ReactComponent };